import __request__ from 'routing/request';
/**
 * GET request to Data Node's API
 */
export function requestGet(path: string, hostname: string): Promise<unknown> {
    return __request__('GET', `/datanodes/${hostname}/rest/${path}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * POST request to Data Node's API
 */
export function requestPost(path: string, hostname: string): Promise<unknown> {
    return __request__('POST', `/datanodes/${hostname}/rest/${path}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * PUT request to Data Node's API
 */
export function requestPut(path: string, hostname: string): Promise<unknown> {
    return __request__('PUT', `/datanodes/${hostname}/rest/${path}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * DELETE request to Data Node's API
 */
export function requestDelete(path: string, hostname: string): Promise<unknown> {
    return __request__('DELETE', `/datanodes/${hostname}/rest/${path}`, null, {}, {
        'Accept': ['application/json']
    });
}
